import "./input-text.css";

const InputText = ({
  type = "text",
  name,
  title,
  error,
  min,
  max,
  register,
  disabled = false,
  value,
  onChange,
}) => {
  const inputProps = register
    ? { ...register(name) }
    : { value: value ?? "", onChange };

  return (
    <div className="input-div">
      <input
        type={type}
        className="input-form"
        autoComplete="off"
        placeholder=" "
        disabled={disabled}
        min={min}
        max={max}
        {...inputProps}
      />
      <label htmlFor={name} className="label-form">
        {title}
      </label>
      {error && <span className="fade-in">{error}</span>}
    </div>
  );
};

export default InputText;
